export default "__VITE_ASSET__Cs9g6$0U__"